import { Box, Typography } from '@mui/material';

interface Props {
  children?: React.ReactElement<unknown>;
  title?: string
  subTitle?: string
  fontSize?: string
  padding?: string
}

export default function ContentTitle(props: Props) {
  return (
    <>
      <Typography variant="h2" sx={(theme) => ({
        padding: props.padding || '0.5rem 0 0 0',
        fontWeight: 'bold',
        fontSize: '3.5rem',
        wordBreak: 'break-all',
        'span': {
          [theme.breakpoints.up('xs')]: {
            fontSize: props.fontSize || '2.5rem',
          },
          [theme.breakpoints.up('md')]: {
            fontSize: props.fontSize || '3rem',
          },
          [theme.breakpoints.up('lg')]: {
            fontSize: props.fontSize || '3.5rem',
          }
        },
        '.primary': {
          color: theme.palette.primary.main,
        },
        '.secondary': {
          color: theme.palette.secondary.main,
        }
      })}>
        <Box component={'span'} className={"primary"}>
          {props.title?.slice(0, 1)}
        </Box>
        <Box component={'span'} className={"secondary"}>
          {props.title?.slice(1, 2)}
        </Box>
        <Box component={'span'}>
          {props.title?.slice(2)}
        </Box>
      </Typography >
      {props.subTitle &&
        <Typography variant="h2" sx={(theme) => ({
          padding: '0.25rem 0 0 0.25rem ',
          fontWeight: 'bold',
          fontSize: '1rem',
          wordBreak: 'break-all',
          'span': {
            [theme.breakpoints.up('xs')]: {
              fontSize: '0.9rem',
            },
            [theme.breakpoints.up('md')]: {
              fontSize: '0.95rem',
            },
            [theme.breakpoints.up('lg')]: {
              fontSize: '1rem',
            }
          },
        })}>
          <Box component={'span'}>
            {props.subTitle}
          </Box>
        </Typography >
      }
    </>
  );
}